import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLines } from "../components/Reveal";
import EditorialMarquee from "../components/Marquee";
import { SERVICES } from "../lib/data";

export default function Services() {
  return (
    <div data-testid="services-page" className="pt-28 md:pt-36">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10">
        <p className="font-sans text-xs tracking-[0.4em] uppercase text-[#7D8C7A] mb-8">
          Services
        </p>
        <h1 className="font-serif text-[#2C3C30] text-6xl md:text-8xl lg:text-[8vw] leading-[0.9] tracking-tighter">
          <MaskedLines
            lines={["Care built", <em key="e" className="text-[#7D8C7A]">around you.</em>]}
          />
        </h1>
        <Reveal delay={0.4}>
          <p className="font-sans text-lg md:text-xl text-[#566158] max-w-2xl mt-10 leading-relaxed">
            Structured, clinical and deeply personal — each service is designed
            to move you from confusion and discomfort toward a calmer gut and a
            healthier life.
          </p>
        </Reveal>
      </section>

      {/* Detailed services */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-32 space-y-6">
        {SERVICES.map((srv, i) => (
          <Reveal key={srv.num}>
            <div
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start border-t border-[#2C3C30]/15 pt-10 md:pt-14"
              data-testid={`service-detail-${srv.num}`}
            >
              <div className="md:col-span-1">
                <span className="font-serif text-4xl text-[#7D8C7A]">
                  {srv.num}
                </span>
              </div>
              <div className="md:col-span-6">
                <h2 className="font-serif text-4xl md:text-5xl text-[#2C3C30] tracking-tight mb-5">
                  {srv.title}
                </h2>
                <p className="font-sans text-lg text-[#566158] leading-relaxed max-w-xl">
                  {srv.desc}
                </p>
              </div>
              <div className="md:col-span-5">
                <ul className="space-y-4">
                  {srv.points.map((p) => (
                    <li
                      key={p}
                      className="flex items-center gap-3 font-sans text-[#2C3C30] border-b border-[#2C3C30]/10 pb-4"
                    >
                      <span className="flex items-center justify-center w-6 h-6 rounded-full bg-[#2C3C30] shrink-0">
                        <Check size={14} className="text-[#F7F6F2]" />
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <EditorialMarquee />

      {/* Featured gut program */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-40">
        <div className="md:col-span-6">
          <Reveal>
            <p className="font-sans text-xs tracking-[0.4em] uppercase text-[#7D8C7A] mb-6">
              Signature program
            </p>
            <h2 className="font-serif text-5xl md:text-6xl text-[#2C3C30] tracking-tight leading-[0.95]">
              The Gut Reset Journey
            </h2>
            <p className="font-sans text-lg text-[#566158] leading-relaxed mt-8 max-w-xl">
              A guided multi-week protocol for IBS (a sensitive gut that cramps,
              bloats & causes irregular bowels), SIBO (too many bacteria in the
              small intestine, causing gas & bloating), IBD (long-term gut
              inflammation, like Crohn&rsquo;s or colitis) and reflux. We move
              through assessment, elimination, reintroduction and microbiome
              rebuilding — with clinician support at every step, so you never
              navigate the hard parts alone.
            </p>
            <Link
              to="/contact"
              data-testid="services-book-cta"
              className="group inline-flex items-center gap-3 mt-10 rounded-full bg-[#2C3C30] px-8 py-4 text-[#F7F6F2] font-medium transition-colors duration-300 hover:bg-[#1A211D]"
            >
              Start your journey
              <ArrowUpRight
                size={18}
                className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
